import { DE_LOCALE } from '../../Constants/Locale.constants';
import { Locale } from '../../Entities/Locale/Locale.entity';

export const getReviewsPathSegment = (locale: Locale) => {
  return locale === DE_LOCALE ? 'auto-tests' : 'reviews';
};
